export { default as Footer } from './Footer.jsx';


// WEBPACK FOOTER //
// ./src/components/Footer/index.js